/**
 * H2C Backend
 * An ASP.NET Core Web API for managing H2C User 
 *
 * The version of the OpenAPI document: V40:2026_02_04_10_21
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TUserDTO { 
    user_id?: number;
    user_first_name?: string | null;
    user_last_name?: string | null;
    user_mail?: string | null;
    user_unit_type_id?: number;
    user_company_type_id?: number;
    user_is_company_admin?: boolean;
    user_company_name?: string | null;
}

